import { Loader, useMantineTheme } from '@any-ui-react/core';
import classNames from 'classnames';
import type { ReactNode } from 'react';

interface SpinnerProps {
  spinner?: ReactNode;
  className?: string;
}

export const Spinner = ({ spinner, className = '' }: SpinnerProps) => {
  const { other } = useMantineTheme();

  return (
    <div className={classNames('flex', 'flex-1', 'items-center', 'justify-center', className)}>
      {spinner || other.spinner?.() || <Loader color="gray" />}
    </div>
  );
};
